import React, { useCallback, useEffect, useState } from "react";
import { useRoutes } from "react-router-dom";
import { HelmetProvider, Helmet } from "react-helmet-async";
import { CacheProvider } from "@emotion/react";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import LocalizationProvider from "@mui/lab/LocalizationProvider";

import axios from "./utils/axios/v1/adminAxios";

import "./i18n";
import ThemeCustomization from "./theme";
import routes from "./routes";

// import { store } from "./redux/store";
import createEmotionCache from "./utils/createEmotionCache";

import Loader from "./components/Loader";

import { AuthProvider } from "./contexts/JWTContext";
import { EffectiveFeaturesProvider } from "./contexts/user/EffectiveFeaturesContext";
import { NotificationProvider } from "./contexts/NotificationContext";
import ErrorBoundary from "./pages/error/ErrorBoundary";
import OnboardAIO from "./pages/application/admin/onboard";
import { GuestProvider } from "./contexts/super/GuestContext";
const clientSideEmotionCache = createEmotionCache();

function App({ emotionCache = clientSideEmotionCache }) {
  const content = useRoutes(routes);
  const [isAIOOnboardingComplete, setIsAIOOnboardingComplete] = useState(!(process.env?.REACT_APP_ALL_IN_ONE === "true"));
  const [loading, setLoading] = useState(false);

  const getAIOStatus = useCallback(async () => {
    setLoading(true);
    try {
      const response = await axios.get("/ssl_aio");
      if (response.data && response.data?.status) {
        setIsAIOOnboardingComplete(true);
      } else {
        setIsAIOOnboardingComplete(false);
      }
    } catch (err) {
      setIsAIOOnboardingComplete(false);
    }
    setLoading(false);
  }, []);

  useEffect(() => {
    if (process.env?.REACT_APP_ALL_IN_ONE === "true") {
      getAIOStatus();
    }
  }, [getAIOStatus]);

  return loading ? (
    <Loader />
  ) : isAIOOnboardingComplete ? (
    <ThemeCustomization>
      <CacheProvider value={emotionCache}>
        <HelmetProvider>
          <Helmet titleTemplate="%s | Layerd AI" defaultTitle="Layerd AI" />
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <AuthProvider>
              <EffectiveFeaturesProvider>
                <NotificationProvider>
                  <ErrorBoundary>{content}</ErrorBoundary>
                </NotificationProvider>
              </EffectiveFeaturesProvider>
            </AuthProvider>
          </LocalizationProvider>
        </HelmetProvider>
      </CacheProvider>
    </ThemeCustomization>
  ) : (
    <ThemeCustomization>
      <CacheProvider value={emotionCache}>
        <HelmetProvider>
          <GuestProvider>
            <OnboardAIO />
          </GuestProvider>
        </HelmetProvider>
      </CacheProvider>
    </ThemeCustomization>
  );
}

export default App;
